import actionTypes from '../actions/action-types';

export const initialState = {
  isLoading: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_REPORTS_PACK_REQUEST:
    case actionTypes.DOWNLOAD_REPORTS_PACK_SUCCESS:
    case actionTypes.DOWNLOAD_REPORTS_PACK_FAILURE:
      return {
        isLoading: action.isLoading,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/download-report-page/reducers/download-report-page.reducer.js